
import { TYPE, canOnlyGo, canGo, cannotGo } from "./network/network_api";
import { REQUEST_TYPE } from "./network/net";
import Stream from "./frp/stream";

export default function(
    $request,
    $error,
    ui,
    $winningRegularStop,
    parent,
)
{
    const space = parent.child( "autoplay" );
    
    const $isAutoplay = ui.s( "isAutoplay", false );
    const $state = parent.s( "state" );
    const $pending = parent.s( "pending" );
    
    const cancel = () => $isAutoplay.next( false );
    $error.on( cancel );
    $state
        .filter( state =>
            //canGo( TYPE.FREESPIN, state )
            //||
            (
                state.type != TYPE.REGULAR
                &&
                state.type != TYPE.FINAL
            )
        )
        .on( cancel );
    
    //with ui:
    ui.s( "autoplayOn" ).map( () => true ).subscribe( $isAutoplay );
    ui.s( "autoplayOff" ).on( cancel );
    ui.s("setLines").on( cancel );
    
    const $tryAutoplay = space.s( "tryAutoplay" );
    $isAutoplay.to( $tryAutoplay );
    //delay amount doesn't matter - just to ensure that bet was already downsampled - cannot rely on streams here because bet calculation is stream with itself :(
    $state.delay( 300 ).to( $tryAutoplay );
    $pending.delay( 300 ).to( $tryAutoplay );
    $tryAutoplay
        .with(
            $isAutoplay,
            $state,
            $pending,
            ui.s( "canPay" ),
            ui.s( "canBet" ),
            ( _, isAutoplay, state, pending, canPay, canBet ) => ({ isAutoplay, state, pending, canPay, canBet })
        )
        .filter( ({ isAutoplay, state, pending, canPay, canBet }) =>
            isAutoplay
            &&
            state.type == TYPE.FINAL
            &&
            pending === undefined
            &&
            canBet
        )
        .on( ({ canPay }) =>
        {
            if ( ! canPay )
            {
                cancel();
                return;
            }
            space.s( "initiate" ).next();
        } );
    
    //bonus, freegames, whatever ... cancels autoplay:
    $winningRegularStop
        .filter( state => cannotGo( TYPE.FINAL, state ) )
        .on( () => cancel() );
    
    //to avoid spin prolongation based on events from previous spins:
    const $force = $winningRegularStop
        .map( _ => _ )
        .name( space, "force" )
        .filter( state => canGo( TYPE.FINAL, state ) )
        .map( () => ({ oudated : false }) );
    $isAutoplay.filter(is => is).map(() => ({ oudated : false })).to($force);
    $state
        .any( $pending )
        .with( $force, ( _, force ) => force ? force.outdated = true : undefined );
    $force 
        .delay( 3500 )
        .filter( ({ outdated }) => ! outdated )
        .with(
            $isAutoplay,
            $state,
            $pending,
            ( _, isAutoplay, state, pending ) => ({ isAutoplay, state, pending }) )
        .filter( ({ isAutoplay, state, pending }) =>
            isAutoplay
            &&
            canOnlyGo( TYPE.FINAL, state )
            &&
            pending === undefined
        )
        .map( () => ({ type : REQUEST_TYPE.TAKE_WIN }) )
        .to( $request );
    
    return space;
}




// WEBPACK FOOTER //
// ./src/library/autoplay.es6